import {
  PRESENTISMO_LOADING,
  PRESENTISMO_SUCCESS,
  PRESENTISMO_ERROR,
  PRESENTISMO_RESET,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import presentismoInitialState from "../initialStates/presentismoInitialState";

const presentismo = (state, { payload, type }) => {
  switch (type) {
    case PRESENTISMO_LOADING:
      return {
        ...state,
        presentismo: {
          ...state.presentismo,
          error: false,
          loading: true,
        },
      };
    case PRESENTISMO_SUCCESS:
      return {
        ...state,
        presentismo: {
          ...state.presentismo,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case PRESENTISMO_ERROR:
      return {
        ...state,
        presentismo: {
          ...state.presentismo,
          error: payload,
          loading: false,
        },
      };

    case PRESENTISMO_RESET:
      return presentismoInitialState;
    case RESET_PORTAL_CONTEXT:
      return presentismoInitialState;

    default:
      return state;
  }
};

export default presentismo;
